import type { OfferAddon, } from 'BrokerTsLib/src/dtos'
import { createContext, useContext } from 'react'

import { useCalculateAddonOffers, useGetAddonOffers } from '../hooks/useOfferAddon'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'

export const offersAddonContext = createContext<IOffersContext<OfferAddon>>(defaults as any)

function OffersAddonProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      signalRCalcFinishedEventName='AddonCalcFinished'
      useGetOffers={useGetAddonOffers}
      useCalculateOffers={useCalculateAddonOffers}
      context={offersAddonContext as any}
    >
      {props.children}
    </OffersProvider>
  )
}

export default OffersAddonProvider

export const useOffersAddonContext = () => {
  const context = useContext(offersAddonContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOffersAddonContext must be used within a OffersAddonProvider!')
  }

  return context
}

